var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-card',[_c('bean-list',{attrs:{"columns":_vm.columns,"value":_vm.data,"size":"mini"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }